import withDraft from '@/utils/draftHelper';
import findResult, { removeItemByCode } from '@/utils/resultsHelper';
import { closeDatasetNamespacesState, findAllDatasetNamespaces } from './state';
import actions from '../../constants';

const destroyDataset = withDraft((draft, { items }) => {
  findAllDatasetNamespaces(draft, { items }).forEach((category) => {
    items.forEach(({ code }) => {
      const item = findResult(draft.namespaces, category, code);
      if (item) {
        draft.namespaces[category].results = removeItemByCode(draft.namespaces[category].results, item);
      }
    });
  });
});

export default {
  [actions.DESTROY_DATASET]: destroyDataset,
  [actions.FINISH_DATASET_WIZARD]: closeDatasetNamespacesState,
};
